import { GenericErrorBoundary, LeftSideBar, Navigation, UserMenuTopBar } from 'components/core-v2'

import { UnitTransfersMain } from '../unit-transfers-main/unit-transfers-main'

export const UnitTransfersWrapper = () => (
  <GenericErrorBoundary>
    <LeftSideBar
      leftElement={<Navigation />}
      mainElement={<UnitTransfersMain />}
      topBarElement={<UserMenuTopBar />}
    />
  </GenericErrorBoundary>
)
